import classNames from 'classnames';
import { FC, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

import styles from './business-hub-footer-contact-us.module.scss';

interface Props {
    rounded?: boolean;
}

export const BusinessHubFooterContactUs: FC<Props> = (props) => {
    const { rounded } = props;

    const [isShowMessage, setIsShowMessage] = useState<boolean>(false);

    const { ref, inView } = useInView({ triggerOnce: true });

    const handleOnSuccess = () => {
        setIsShowMessage(true);
    };

    useEffect(() => {
        if (!inView) {
            return;
        }

        const MktoForms2 = (window as any).MktoForms2;

        const loadMarketoForm = () => {
            const newScriptElement = document.createElement('script');
            newScriptElement.onload = () => {
                triggerMarketoForm();
            };
            newScriptElement.setAttribute('src', 'https://www.workwithsquare.com/js/forms2/js/forms2.min.js');

            document.body.appendChild(newScriptElement);
        };

        const triggerMarketoForm = () => {
            if (!(window as any).MktoForms2) {
                return;
            }

            (window as any).MktoForms2?.loadForm('//www.workwithsquare.com', '424-IAB-218', 11166, function (form: any) {
                form.onSuccess(function () {
                    handleOnSuccess();
                    return false;
                });
            });
        };

        if (!MktoForms2) {
            loadMarketoForm();
        } else {
            triggerMarketoForm();
        }
    }, [inView]);

    return (
        <>
            <div id="contact-us" className={styles.section} ref={ref}>
                <div className={classNames(styles.background, { [styles.rounded]: rounded })}> </div>
                <div className={styles.title}>Contact us.</div>
                {isShowMessage ? (
                    <div className={styles.sectionAfterSubmit}>
                        <span>
                            Thank you for your interest.
                            <br />
                            Our team will be in touch with you shortly.
                        </span>
                    </div>
                ) : (
                    <form id="mktoForm_11166" className={styles.sectionForm}></form>
                )}
            </div>
        </>
    );
};
